import React from "react";
import { Box, Card, CardActionArea, Skeleton, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const KpiTile = ({
  label,
  value,
  unit,
  accent,
  icon,
  navigateTo,
  loading = false,
  caption,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const accentColor = accent || theme.palette.primary.main;

  const Wrapper = ({ children }) =>
    navigateTo ? (
      <CardActionArea onClick={() => navigate(navigateTo)} sx={{ height: "100%" }}>
        {children}
      </CardActionArea>
    ) : (
      <Box sx={{ height: "100%" }}>{children}</Box>
    );

  return (
    <Card
      sx={{
        position: "relative",
        height: "100%",
        overflow: "hidden",
        borderLeft: `3px solid ${accentColor}`,
        "&:hover": {
          borderLeftColor: accentColor,
          boxShadow: `0 4px 24px ${alpha(accentColor, 0.18)}`,
        },
      }}
    >
      <Wrapper>
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 0.5, height: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {icon && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 28,
                  height: 28,
                  borderRadius: 1,
                  backgroundColor: alpha(accentColor, 0.12),
                  color: accentColor,
                }}
              >
                {icon}
              </Box>
            )}
            <Typography variant="subtitle2" color="text.secondary">
              {label}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.75, mt: 0.5 }}>
            {loading ? (
              <Skeleton width={64} height={36} />
            ) : (
              <Typography
                variant="h4"
                sx={{ color: "text.primary", lineHeight: 1.1 }}
              >
                {typeof value === "number" ? value.toLocaleString() : value ?? "—"}
              </Typography>
            )}
            {unit && (
              <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                {unit}
              </Typography>
            )}
          </Box>
          {caption && (
            <Typography variant="caption" color="text.secondary" sx={{ mt: "auto" }}>
              {caption}
            </Typography>
          )}
        </Box>
      </Wrapper>
    </Card>
  );
};

export default KpiTile;
